import React, { useEffect, useRef, useState, useCallback } from "react";
import { Player } from 'bitmovin-player';
import { UIFactory } from 'bitmovin-player-ui';
import Styles from './VideoPlayer.module.css';
import 'bitmovin-player/bitmovinplayer-ui.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from "react-slick";
import { useViewItemList } from '../hooks/useViewItemList';
import { trackSelectItem, trackViewItem, trackAutoplayNavigation } from '../lib/gtm';
import { BsChevronLeft, BsChevronRight, BsChevronUp, BsChevronDown, BsShare } from 'react-icons/bs';
import { FaFacebook, FaWhatsapp, FaXTwitter, FaLink, FaArrowLeft, FaArrowRight, FaPlay, FaPause } from 'react-icons/fa6';
import MobileVerticalVideoPlayer from "./VideoPlayer/MobileVerticalVideoPlayer";
import VerticalVideoPlayer from "./VideoPlayer/VerticalVideoPlayer";

const BITMOVIN_LICENSE_KEY = '34a49c54-19ea-45e1-a196-cda7e07caeb3';

// Custom Arrow Components for horizontal slider
const CustomPrevArrow = (props) => {
    const { onClick, className } = props;

    return (
        <button
            className={`${Styles.customArrow} ${Styles.customPrevArrow} ${className}`}
            onClick={onClick}
            aria-label="Previous video"
            type="button"
        >
            <FaArrowLeft />
        </button>
    );
};

const CustomNextArrow = (props) => {
    const { onClick, className } = props;

    return (
        <button
            className={`${Styles.customArrow} ${Styles.customNextArrow} ${className}`}
            onClick={onClick}
            aria-label="Next video"
            type="button"
        >
            <FaArrowRight />
        </button>
    );
};

const VideoPlayer = ({ title, titleLink, titleLinkText, Api_url, adTag, logo, logoName, gtmConfig }) => {
    const [playlist, setPlaylist] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [sliderLoaded, setSliderLoaded] = useState(false);

    const sliderRef = useRef(null);

    const [combinedSlides, setCombinedSlides] = useState([])
    const [meta, setMeta] = useState({})
    const [isVideoPlaying, setIsVideoPlaying] = useState(true)
    const [isAdPlaying, setIsAdPlaying] = useState(false)

    const videoRailRef = useViewItemList(
        playlist,
        gtmConfig.listId,
        gtmConfig.listName,
        gtmConfig.category,
        gtmConfig.category2
    );

    // Minimum swipe distance (in px)
    const minSwipeDistance = 50;

    const formatDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    };

    // const handleAdButton = () => {
    //     if (isVideoPlaying) {
    //         playerRef.current.pause();
    //     } else {
    //         playerRef.current.play();
    //     }
    //     setIsVideoPlaying(!isVideoPlaying);
    // };

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const loadPlaylist = async () => {
            try {
                const response = await fetch(Api_url);
                const data = await response.json();

                const limitedPlaylist = {
                    ...data,
                    playlist: data.playlist.slice(0, 10)
                }

                const updatedPlaylist = limitedPlaylist.playlist.map((video) => {
                    return {
                        ...video,
                        description: `▶︎ &nbsp ${formatDuration(video.duration)}`,
                    };
                });

                setPlaylist(updatedPlaylist);
                const slides = []
                let adCount = 0
                updatedPlaylist.forEach((video, i) => {
                    slides.push({ ...video, type: 'video', index: i, hlsSource: video.sources?.find(s => s.type === 'application/vnd.apple.mpegurl')?.file })
                    // if ((i + 1) % 3 === 0) {
                    //     slides.push({
                    //         type: 'ad',
                    //         adId: `div-gpt-ad-tonton-${adCount}`,
                    //         index: `ad-${adCount}`,
                    //     })
                    //     adCount++
                    // } //removed ad logic as of now
                })
                setCombinedSlides(slides)
                setLoading(false);
                console.log('Playlist loaded successfully');
            } catch (error) {
                console.error('Failed to load playlist:', error);
                setLoading(false);
            }
        };

        loadPlaylist();
    }, [Api_url]);

    // const openModal = (video, index) => {
    //     trackSelectItem(video, index, gtmConfig.listId, gtmConfig.listName, gtmConfig.category, gtmConfig.category2);
    //     setSelectedVideo(video);
    //     setCurrentVideoIndex(index);
    //     setShowModal(true);
    //     document.body.classList.add('modal-open');
    // };

    const openModal = (video, index) => {
        trackSelectItem(video, index, gtmConfig.listId, gtmConfig.listName, gtmConfig.category, gtmConfig.category2);
        setSelectedVideo(video)
        setCurrentVideoIndex(index)
        setMeta({ title: video.title, description: video.description, image: video.image, url: window.location.href, type: 'video.other' })
        setShowModal(true)
        document.body.classList.add('modal-open')
    }

    // const closeModal = () => {
    //     // Clean up player and UI properly
    //     cleanupPlayer();

    //     setShowModal(false);
    //     setSelectedVideo(null);
    //     document.body.classList.remove('modal-open');
    // };

    const closeModal = () => {
        setShowModal(false)
        setSelectedVideo(null)
        document.body.classList.remove('modal-open')
    }


    const handleShare = () => {
        setShareModalOpen(true);
    };

    const copyToClipboard = () => {
        const shareUrl = window.location.href;
        navigator.clipboard.writeText(shareUrl).then(() => {
            alert('Link copied to clipboard!');
        });
    };

    const shareOnSocial = (platform) => {
        const shareUrl = window.location.href;
        const shareText = `Check out this video: ${selectedVideo?.title}`;

        let url = '';
        switch (platform) {
            case 'facebook':
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
                break;
            case 'twitter':
                url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
                break;
            case 'whatsapp':
                url = `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`;
                break;
            default:
                return;
        }

        window.open(url, '_blank');
        setShareModalOpen(false);
    };

    // Base settings
    const baseSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        swipeToSlide: true,
        afterChange: () => {
            if (!sliderLoaded) {
                setSliderLoaded(true);
            }
        },
    };

    // Desktop settings with custom arrows
    const desktopSettings = {
        ...baseSettings,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };

    // Mobile settings with default arrows
    const mobileSettings = {
        ...baseSettings,
        // arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };

    // Choose settings based on screen size
    const settings = {
        ...(isMobile ? mobileSettings : desktopSettings),
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    // arrows: true,

                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    // arrows: true,
                }
            }
        ]
    };

    // Slider settings for horizontal scrolling (UNCHANGED)
    // const settings = {
    //     dots: false,
    //     infinite: false,
    //     speed: 500,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     initialSlide: 0,
    //     swipeToSlide: true,
    //     // prevArrow: <CustomPrevArrow />,
    //     // nextArrow: <CustomNextArrow />,
    //     responsive: [
    //         {
    //             breakpoint: 1440,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //             }
    //         },
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 1,
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 2.5,
    //                 slidesToScroll: 1,
    //                 arrows: true,
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1.5,
    //                 slidesToScroll: 1,
    //                 arrows: true,
    //             }
    //         }
    //     ]
    // };

    const VideoThumbnail = ({ video, onClick, index }) => (
        <div
            className={Styles.videoWrapper}
            onClick={() => onClick(video, index)}
        >
            {/* Add a badge if needed */}
            {/* <div className={Styles.channelBadge}>
                <img src={logo} alt="Channel" />
            </div> */}
            <img
                src={video.image}
                alt={video.title}
                className={Styles.videoThumbnail}
                loading="lazy"
            />
            <div className={Styles.titleDiv}>
                {/* Duration in top left of title area */}
                <div className={Styles.durationBadge}>
                    <span>{formatDuration(video.duration)}</span>
                </div>
                <p className={Styles.videoTitle}>{video.title}</p>
                {/* <p className={Styles.videoMeta}>{video.views || '1k'} views • {video.age || '1d ago'}</p> */}
            </div>
        </div>
    );

    const logoClassMap = {
        'logo-butv': Styles.butvLogo,
        'logo-ob': Styles.obLogo,
        // add more custom logos if needed
    };

    const logoClass = logoName ? logoClassMap[logoName] || '' : Styles.basicLogo;

    return (
        <div className="block block-video-player">
            <div className={`container ${Styles.titleContainer}`}>
                <div className={Styles.videoHeaderLeft}>
                    <div className="logo">
                        <img src={logo} alt="Logo" className={logoClass} />
                    </div>
                    <div className={Styles.blockTitle}>
                        <a href={titleLink}>{titleLinkText || title}</a>
                    </div>
                </div>
            </div>

            <div className={Styles.videoContainer} ref={videoRailRef}>
                <div className={`${Styles.sliderContainer} px-2`}>
                    {loading ? (
                        <div className={Styles.loadingContainer}>
                            <div className={Styles.spinner}></div>
                            <span>Loading videos...</span>
                        </div>
                    ) : (
                        <Slider ref={sliderRef} {...settings}>
                            {playlist.map((video, index) => (
                                <div key={video.mediaid} className={Styles.slideItem}>
                                    <VideoThumbnail
                                        video={video}
                                        onClick={openModal}
                                        index={index}
                                    />
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>
            </div>

            {showModal && selectedVideo && (
                <div style={{ position: 'fixed', inset: 0, zIndex: 9999 }}>
                    {isMobile
                        ? <MobileVerticalVideoPlayer
                            videoId={String(selectedVideo.mediaid)}
                            playlist={playlist}
                            combinedSlides={combinedSlides}
                            currentVideo={selectedVideo}
                            onChangeMeta={setMeta}
                            onClose={closeModal}
                            adTag={adTag}
                            gtmConfig={gtmConfig}
                        />
                        : <VerticalVideoPlayer
                            videoId={String(selectedVideo.mediaid)}
                            playlist={playlist}
                            combinedSlides={combinedSlides}
                            currentVideo={selectedVideo}
                            onChangeMeta={setMeta}
                            onClose={closeModal}
                            adTag={adTag}
                            gtmConfig={gtmConfig}
                        />
                    }
                </div>
            )}

            {shareModalOpen && (
                <div className={Styles.shareModal}>
                    <div className={Styles.shareModalOverlay} onClick={() => setShareModalOpen(false)}></div>
                    <div className={Styles.shareModalContent}>
                        <div className={Styles.shareModalHeader}>
                            <h3>Kongsi Sekarang</h3>
                            <button
                                className={Styles.shareModalClose}
                                onClick={() => setShareModalOpen(false)}
                            >
                                ×
                            </button>
                        </div>
                        <div className={Styles.shareModalBody}>
                            <div className={Styles.shareIcons}>
                                <button
                                    className={`${Styles.shareIcon} ${Styles.shareFb}`}
                                    onClick={() => shareOnSocial('facebook')}
                                >
                                    <FaFacebook size={24} />
                                </button>
                                <button
                                    className={`${Styles.shareIcon} ${Styles.shareTw}`}
                                    onClick={() => shareOnSocial('twitter')}
                                >
                                    <FaXTwitter size={24} />
                                </button>
                                <button
                                    className={`${Styles.shareIcon} ${Styles.shareWa}`}
                                    onClick={() => shareOnSocial('whatsapp')}
                                >
                                    <FaWhatsapp size={24} />
                                </button>
                            </div>
                            <div className={Styles.shareCopy}>
                                <FaLink size={20} />
                                <input
                                    type="text"
                                    value={window.location.href}
                                    readOnly
                                    className={Styles.shareUrl}
                                />
                                <button
                                    className={Styles.copyButton}
                                    onClick={copyToClipboard}
                                >
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VideoPlayer;